module.exports = __webpack_public_path__ + "img/task.936def31.gif";